<template>
  <div id="app">
    <component :is="layout">
      <router-view></router-view>
    </component>
    <Loader :loading="loading" />
    <WhatsappButton />
  </div>
</template>

<script>
const defaultLayout = "default";
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import { get, filter } from "lodash";
import i18n from "@/plugins/i18n";
import Loader from "@/components/Loader";
import { arePointsNear } from "@/helper/helper";
import WhatsappButton from "@/components/WhatsappButton.vue";
export default {
  name: "App",
  components: {
    Loader,
    WhatsappButton
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
    ...mapState({
      lang: state => get(state, "app.lang", false),
      location: state => get(state, "app.location", null),
      campingClubs: state => get(state, "campingClubs.list", []),
      areInCampings: state => get(state, "app.areInCampings", []),
      distance: state => get(state, "app.general.distance", 1),
      title: state => get(state, "app.general.title", "Atlantica Parc"),
      loading: state =>
        get(state, "app.loading", false) ||
        get(state, "types.loading", false) ||
        get(state, "categories.loading", false) ||
        get(state, "campingClubs.loading", false) ||
        get(state, "hotels.loading", false) ||
        get(state, "blogs.loading", false) ||
        get(state, "cart.loading", false)
    })
  },
  mounted() {
    i18n.locale = this.lang;
    moment.locale(this.lang);
    if (this.$cookies.get("location") !== "requested") {
      this.getCurrentPosition().then(() => {
        this.checkCurrentLocationIsInCamping();
        this.$cookies.set("location", "requested");
      });
    }

    // this.watchPosition();
    this.getGeneral();
    // The landing page holds section titles reused on other pages (campsite list);
    // load it in the current language on every page, not only on the home.
    this.getLandingPage();
    this.getPageTitle().then(() => {
      document.title = this.title;
    });
    this.getHotels();
    this.getAllReferences();
    this.getMenuLeft();
    this.getMenuRight();
    this.getMenuFooter();
    this.getMenuPages();
  },
  methods: {
    ...mapMutations("app", ["setAreInCampings"]),
    ...mapActions("app", [
      "getGeneral",
      "getLandingPage",
      "getMenuLeft",
      "getMenuRight",
      "getMenuFooter",
      "getPageTitle",
      "getMenuPages"
    ]),
    ...mapActions("hotels", ["getHotels", "getAllReferences"]),
    ...mapActions("app", ["getCurrentPosition", "watchPosition"]),
    checkCurrentLocationIsInCamping() {
      const areInCampings = filter(this.campingClubs, camping => {
        const camLat = get(camping, "acf.cam_lat");
        const camLng = get(camping, "acf.cam_lng");
        let campingLocation = {
          lat: camLat,
          lng: camLng
        };
        const isInArea = arePointsNear(
          this.location,
          campingLocation,
          this.distance
        );
        return isInArea;
      });
      this.$vlf.setItem("areInCampings", areInCampings);
      this.$vlf.setItem("lang", this.lang);
      this.setAreInCampings(areInCampings);
    }
  },
  watch: {
    $route() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
